import { Thermometer } from 'lucide-react';
import { formatNumber } from '@/utils/formatNumber';

interface EnvironmentCardProps {
  temperature: {
    current: number;
    average: number;
  };
  humidity: {
    current: number;
    average: number; 
  };
}

export function EnvironmentCard({ temperature, humidity }: EnvironmentCardProps) {
  return (
    <div className="flex flex-col bg-white rounded-[10px] shadow-card p-2 gap-1.5 border border-light-grey h-full">
      <div className="flex items-center gap-1.5">
        <div className=" h-[18px] w-[18px] bg-light-grey rounded flex items-center justify-center">
          <Thermometer className="h-3 w-3 text-primary" />
        </div>
        <h2 className="text-dark-blue heading-7">
          Indoor Environment
        </h2>
      </div>
      <div className="flex gap-2 flex-1">
        {/* Room Temp */}
        <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
          <div className="paragraph-11 text-dark">Room Temp</div>
          <div className="flex items-baseline gap-1">
            <span className="heading-6">{formatNumber(temperature.current, 1)}</span>
            <span className="paragraph-12">°C</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="paragraph-9 text-dark-grey">Today Avg.</span>
            <span className="paragraph-9 text-gray-500">{formatNumber(temperature.average, 1)} °C</span>
          </div>
        </div>

        {/* Relative Humidity */}
        <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
          <div className="paragraph-11 text-dark">Relative Humidity</div>
          <div className="flex items-baseline gap-1">
            <span className="heading-6">{formatNumber(humidity.current, 1)}</span>
            <span className="paragraph-12">%</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="paragraph-9 text-dark-grey">Today Avg.</span>
            <span className="paragraph-9 text-gray-500">{formatNumber(humidity.average, 1)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
}